<form [formGroup]="settingsForm"
  class="db-cdn-full-page-cache-settings" [ngClass]="{'overlay': disableCdn || disablePageCache}">
  <h4 class="db-cdn-full-page-cache-settings__title">Full page cache settings</h4>
  <p class="db-cdn-full-page-cache-settings__desc mt4">Necessary page cache rules are already applied, you can customize or add more rules below:</p>

  <div class="ds-input-wrap mt25">
    <div class="ds-textarea-label-wrap">
      <span class="ds-input-label">Bypass Urls
        <i class="db-icon db-icon-info-lined ml4" [dsTooltip]="bypassUrls" [dsTooltipMode]="'hoverStatic'" dsTooltipAlign="left"></i>
      </span>
    </div>
    <textarea type="text" class="ds-textarea" formControlName="bypassPageUrlRegex"></textarea>
    <span class="ds-input-desc">URLs that shouldn’t be cached</span>
  </div>

  <div class="ds-input-wrap mt25">
    <div class="ds-textarea-label-wrap">
      <span class="ds-input-label">Bypass cookies
        <i class="db-icon db-icon-info-lined ml4" [dsTooltip]="bypassCookies" [dsTooltipMode]="'hoverStatic'" dsTooltipAlign="left"></i>
      </span>
    </div>
    <textarea type="text" class="ds-textarea" formControlName="bypassCookie"></textarea>
    <span class="ds-input-desc">Cookies that shouldn’t be cached</span>
  </div>

  <div class="ds-input-wrap mt25">
    <div class="ds-textarea-label-wrap">
      <span class="ds-input-label">Ignore queries
        <i class="db-icon db-icon-info-lined ml4" [dsTooltip]="ignoreQueries" [dsTooltipMode]="'hoverStatic'" dsTooltipAlign="left"></i>
      </span>
    </div>
    <textarea type="text" class="ds-textarea" formControlName="includeQueryString"></textarea>
    <span class="ds-input-desc">Query strings that will not affect cache</span>
  </div>

  <div class="mt30 text-right">
    <a class="ds-btn-green" (click)="!disablePageCache && !disableCdn && save()"
       [ngClass]="{'ds-btn-disabled': loading
       || (!bypassPageUrlRegex && !settingsForm?.controls?.bypassPageUrlRegex?.value
       && !bypassCookie && !settingsForm?.controls?.bypassCookie?.value
       && !includeQueryString && !settingsForm?.controls?.includeQueryString?.value )}">
      <span *ngIf="!loading">{{'text_saveTags' | dbText | lowerCaseSpecificWords}}</span>
      <db-loading-circular-spinner *ngIf="loading"></db-loading-circular-spinner>
    </a>
  </div>
</form>

<ng-template #bypassUrls>
  <div class="db-cdn-tooltip">
    <p>To bypass pages/URLs from being cached<br/> add any keywords that match the URL you<br/> want to bypass. Separate the keywords<br/>
      with a new line or space. For example, if<br/> you want to exclude <a>https://example.com/team</a>,<br/> add “/team/“ to the keywords list.<br/>
      This will also exclude <a>https://example.com/<br/>team/member1</a><br/><br/> <b>Important:</b><br/> There is no need for regex, simply add a<br/>
      keyword that uniquely matches the URL.</p>
  </div>
</ng-template>

<ng-template #bypassCookies>
  <div class="db-cdn-tooltip">
    <p>Cached pages will be delivered to everyone,<br/> even if any cookies are present. Some<br/> cookies may affect the content. To avoid<br/>
      this, you can add cookies which will be<br/> bypassed and not cached.<br/>
      For example, in WordPress, non-cached<br/> pages should be delivered to users after<br/>
      logging in. You can add cookie names<br/> separated with a new line or space, and the<br/>
      pages will be delivered different from the<br/> origin when the cookie is found. Some<br/>
      cookies are already added for your<br/> WordPress website.</p>
  </div>
</ng-template>

<ng-template #ignoreQueries>
  <div class="db-cdn-tooltip">
    <p>A separate cache will be generated when we<br/> find query strings. You can specify the<br/>
      queries separating them with a new line or<br/> space and we will ignore them without<br/> rewriting the URLs.<br/>
      For example, by default <a>https://<br/>example.com</a> and <a>https://example.com?<br/>ref=landing</a> will serve different caches. You<br/>
      can add query strings like “ref" so that we<br/> ignore that query string and deliver a<br/>
      cached page, for both URLs.<br/><br/>
      <b>Important:</b><br/>
      No need for regex in keywords. For<br/> example, “utm_" is enough for query<br/>
      strings like utm_source, utm_campaign,<br/> utm_medium etc.</p>
  </div>
</ng-template>

